import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import scrollViewTo from '../../../util/scrollViewTo';

const GlobalStats = ({ stats }) => (
  <div>
    <MediaQuery maxWidth={991}>
      <ul className="global-stats global-stats visible-xs visible-sm">
        {stats.map(({ key, label, value, isLink, scrollToId, linkAttrs, tooltip, hidden }) => {
          const statScrollTo = scrollToId
            ? scrollViewTo.bind(null, { id: scrollToId, offset: 144 })
            : '';
          return (
            <li key={key} className={`global-stat ${hidden ? 'hidden' : ''}`}>
              <span className="stat-value stat-value-v2">{value}</span>
              {!isLink && <span className="stat-label">{label}</span>}
              {isLink && (
                <a className="stat-label stat-link" onClick={statScrollTo} {...linkAttrs}>
                  {label}
                </a>
              )}
              {tooltip && (
                <div className="with-tooltip" data-tooltip={tooltip}>
                  <i className="zolaicon zolaicon-info" />
                </div>
              )}
            </li>
          );
        })}
      </ul>
    </MediaQuery>
    <MediaQuery minWidth={992}>
      <ul className="global-stats visible-md visible-lg">
        {stats.map(({ key, label, value, isLink, scrollToId, linkAttrs, tooltip, hidden }) => {
          const statScrollTo = scrollToId
            ? scrollViewTo.bind(null, { id: scrollToId, offset: 70 })
            : '';
          return (
            <li
              key={key}
              className={`global-stat with-tooltip ${hidden ? 'hidden' : ''}`}
              data-tooltip={tooltip}
            >
              <span className="stat-value">{value}</span>
              {!isLink && <span className="stat-label">{label}</span>}
              {isLink && (
                <a className="stat-label stat-link" onClick={statScrollTo} {...linkAttrs}>
                  {label}
                </a>
              )}
            </li>
          );
        })}
      </ul>
    </MediaQuery>
  </div>
);

GlobalStats.propTypes = {
  stats: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.element.isRequired]),
      value: PropTypes.number.isRequired,
      isLink: PropTypes.bool,
      linkAttrs: PropTypes.shape({}),
      tooltip: PropTypes.string,
      hidden: PropTypes.bool,
    })
  ),
};

export default GlobalStats;



// WEBPACK FOOTER //
// ./src/components/manage/common/GlobalStats.jsx